import { Serie } from "@nivo/line";
import { ChartDatasetModel } from "models/chartConfiguration/chartDatasetModel";
import { InitialDemandOutturnModel } from "models/demandOutturn/InitialDemandOutturnModel";

const addInitialDemandOutturnDataToSeries = (
  series: Serie[],
  data: InitialDemandOutturnModel
): Serie[] =>
  series.reduce(
    (prev, curr) => [
      ...prev,
      {
        id: curr.id,
        colour: curr.colour,
        data: [
          ...curr.data,
          {
            x: new Date(data.startTime),
            y: data[curr.id as keyof InitialDemandOutturnModel],
            settlementPeriod: data.settlementPeriod,
          },
        ],
      },
    ],
    [] as Serie[]
  );

export const transformInitialDemandOutturnModelData = (
  rawData: InitialDemandOutturnModel[],
  datasets: ChartDatasetModel[]
): Serie[] => {
  const initialSeries = datasets
    .filter((entry) => !entry.isHidden)
    .map<Serie>((entry) => ({
      id: entry.dataKey,
      colour: entry.colour,
      data: [],
    }));

  return rawData.reduce(addInitialDemandOutturnDataToSeries, initialSeries);
};
